import { validate } from '@/utils/validations';
import schema from '@/components/FormWrapper/Steps/Trucker/validation';
import { Errors } from '@/components/FormWrapper/Steps/Trucker/types';

import { FormTrucker } from '@/types';

const clearValue = (errors: Errors['trucker'], target: FormTrucker) => {
  Object.keys(errors).forEach((key) => {
    if (target[key] === undefined) return;

    if (typeof errors[key] === 'string') {
      const value = typeof target[key] === 'boolean' ? false : '';
      target[key] = value;
    } else if (typeof errors[key] === 'object') {
      clearValue(errors[key], target[key]);
    }
  });
};

export const validateFormTruckerData = (formTrucker: FormTrucker): FormTrucker => {
  const trucker = { ...formTrucker };
  const errors = validate<Errors>(schema, { trucker });

  if (errors) {
    clearValue(errors.trucker, trucker);
  }

  return trucker;
};
